import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderPaper: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFolderPaper"><Path d="M16.5 5.5H20.5V10.5M3.5 7.5V3.5H16.5V10.5M3.5 7.5H2.5V20.5H21.5V10.5H20.5M3.5 7.5H8.25L11.25 10.5H16.5M20.5 10.5H16.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconFolderPaper;
